<div class="search-services" (window:click)="handleClick($event)">
  <div class="content">
      <span *ngIf="prependIcon" class="{{prependIcon}} prepender" tooltip="{{placeholder}}" placement="right"></span>
      <span *ngIf="_selected && !isOpen && formatGDB" class="fakeplaceholder" [ngClass]="{'has-prepend': prependIcon, 'has-append': appendIcon}" [innerHTML]="formatedGDB(_selected)"></span>
      <span *ngIf="_selected && !isOpen && !formatGDB" class="fakeplaceholder" [ngClass]="{'has-prepend': prependIcon, 'has-append': appendIcon}">{{_selected.name}}</span>
      <input 
          [id]="prefix"
          type="text"
          [ngClass]="{'o': isOpen, 'has-prepend': prependIcon, 'has-append': appendIcon}"
          placeholder="{{_selected ? '' : placeholder}}"
          class="form-control"
          (focus)="focusInput()" 
          [(ngModel)]="filterText" 
          (input)="filterChanged($event.target.value)"
          autocomplete="off"/>
          <i *ngIf="filterText" id="clearField" (click)="$event.preventDefault(); clearFilter();"
            class="fas fa-times btn-xs btn-bordered btn-danger btn-icon float-right nglist-item-action remove__icon mr-2"></i>
          <i class="far" [ngClass]="{'fa-search': isOpen, 'fa-angle-down': !isOpen}"></i>
      <span *ngIf="appendIcon" class="{{appendIcon}} appender"></span>
  </div>
  <div *ngIf="items && items.length" 
      [ngClass]="{'o': isOpen}" 
      class="items">
      <div 
          class="item" 
          *ngFor="let item of items | serviceFilter: filterContent" 
          (click)="selectItem(item);">
          <span *ngIf="formatGDB" [innerHTML]="formatedGDB(item)"></span>
          <span *ngIf="!formatGDB">{{item.name}}</span>
      </div>
  </div>
</div>